import { render, staticRenderFns } from "./BookingCallPop.vue?vue&type=template&id=20660630"
import script from "./BookingCallPop.vue?vue&type=script&lang=js"
export * from "./BookingCallPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20660630')) {
      api.createRecord('20660630', component.options)
    } else {
      api.reload('20660630', component.options)
    }
    module.hot.accept("./BookingCallPop.vue?vue&type=template&id=20660630", function () {
      api.rerender('20660630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BookingCallPop.vue"
export default component.exports